import getQuoteEquipment from '../equipmentModal'
import { adjustWidth } from '../equipmentModal'

/**
 * Function to close all select elements except the one passed as an argument
 * @param elmnt HTML element to close all selects except
 */
export function closeAllSelect( elmnt: HTMLElement | null ): void {
  const allSelectItems = Array.from( document.getElementsByClassName( 'select-items' ) )
  const allSelectSelected = Array.from( document.getElementsByClassName( 'select-selected' ) )
  allSelectSelected.forEach( ( select, index ) => {
      if ( elmnt === select ) {
          select.classList.remove( 'select-arrow-active' )
      } else {
          allSelectItems[index]?.classList.add( 'select-hide' )
      }
  } )
}

/**
 * Initialize custom select elements
 * @param page Optional page string for callback functionality
 */
export function initializeCustomSelects( page: string | null = null ): void {
  const customSelects = Array.from( document.getElementsByClassName( 'select-input-field' ) )

  customSelects.forEach( selectContainer => {
      const selectElement = selectContainer.getElementsByTagName( 'select' )[0]
      const selectedDiv = document.createElement( 'div' )
      let firstOption = 0
      selectedDiv.className = 'select-selected'
      selectedDiv.tabIndex = 0 // Make it focusable
      selectedDiv.innerHTML = selectElement.options[selectElement.selectedIndex].innerHTML
      selectContainer.appendChild( selectedDiv )

      const itemsDiv = document.createElement( 'div' )
      itemsDiv.className = 'select-items select-hide'
      Array.from( selectElement.options ).forEach( ( option, index ) => {
          if ( index === 0 ) return
          const optionDiv = document.createElement( 'div' )
          optionDiv.innerHTML = option.innerHTML
          optionDiv.tabIndex = 0 // Make it focusable
          optionDiv.addEventListener( 'click', function() {
              if ( ! firstOption ) firstOption = Number( option.value )
              selectElement.selectedIndex = index
              selectedDiv.innerHTML = this.innerHTML
              closeAllSelect( null )

              if ( page === 'services' ) {
                  getQuoteEquipment( Number ( option.value ) )
                  adjustWidth()
              }
          } )
          itemsDiv.appendChild( optionDiv )
      } )
      selectContainer.appendChild( itemsDiv )

      selectElement.selectedIndex = 0
      selectedDiv.innerHTML = itemsDiv?.firstElementChild?.textContent as string
      if ( ! firstOption ) firstOption = Number( selectElement.options[1].value )
      getQuoteEquipment( firstOption )

      selectedDiv.addEventListener( 'click', function ( event: MouseEvent ) {
          event.stopPropagation()
          toggleDropdown( this, itemsDiv )
      } )

      selectedDiv.addEventListener( 'keydown', function( event: KeyboardEvent ) {
          if ( event.key === 'Enter' || event.key === 'ArrowDown' ) {
              event.preventDefault()
              toggleDropdown( this, itemsDiv )
          }
      } )

      // Add keyboard navigation for options
      itemsDiv.addEventListener( 'keydown', function( event: KeyboardEvent ) {
          if ( event.key === 'ArrowDown' || event.key === 'ArrowUp' ) {
              event.preventDefault()
              navigateOptions( this, event.key )
          }
      } )
  } )

  handleSelectHeight()
}

/**
 * Set a max height for the select container if it
 * exceeds the remainder of the screen height.
 */
const handleSelectHeight = () => {
  const selectItems = document.querySelector<HTMLDivElement>( '.select-input-field' )
  const selectItemsContainer = document.querySelector<HTMLDivElement>( '.select-items' )
  if ( selectItems && selectItemsContainer ) {
    const rect = selectItems.getBoundingClientRect()
    const distance = rect.height + rect.top
    const difference = window.innerHeight - distance
    selectItemsContainer.style.maxHeight = `${difference}px`
    selectItemsContainer.style.overflow = 'auto'
  }
}

window.addEventListener( 'resize', () => handleSelectHeight(), { passive: true } )

/**
 * Toggle the dropdown
 * @param selectedDiv HTML element for the selected div
 * @param itemsDiv HTML element for the items div
 */
function toggleDropdown( selectedDiv: HTMLElement, itemsDiv: HTMLElement ): void {
  closeAllSelect( selectedDiv )
  itemsDiv.classList.toggle( 'select-hide' )
  selectedDiv.classList.toggle( 'select-arrow-active' )
}

/**
 * Navigate the options
 * @param itemsDiv Items div
 * @param key Key pressed
 */
function navigateOptions( itemsDiv: HTMLElement, key: string ): void {
  const options = Array.from( itemsDiv.children )
  const focusedIndex = options.findIndex( option => ( option as HTMLElement ).classList.contains( 'option-focused' ) )

  if ( key === 'ArrowDown' || key === 'ArrowUp' ) {
      if ( focusedIndex !== -1 ) {
          options[focusedIndex].classList.remove( 'option-focused' )
      }

      let nextIndex = key === 'ArrowDown' ? focusedIndex + 1 : focusedIndex - 1
      if ( nextIndex >= options.length ) nextIndex = 0
      if ( nextIndex < 0 ) nextIndex = options.length - 1

      options[nextIndex].classList.add( 'option-focused' );
      ( options[nextIndex] as HTMLElement ).focus()

    } else if ( key === 'Enter' && focusedIndex !== -1 ) {
        const focusedOption = options[focusedIndex] as HTMLElement
        focusedOption.dispatchEvent( new MouseEvent( 'click', {
            bubbles: true,
            cancelable: true,
            view: window
        } ) )
    }
}

/**
 * Event listener to close all selects when clicking outside
 */
document.addEventListener( 'click', () => closeAllSelect( null ) )

